import React from "react";
import StudentSearch from "../../student/search";

const SearchLead = () => {
	return <StudentSearch isLeadSearch />;
};

export default SearchLead;
